import moment from 'moment';
import numeral from 'numeral';
import { useCallback } from 'react';
import { EXCEPCION_GARANTIA_ESTADO_COLOR, EXCEPCION_GARANTIA_TIPO, GARANTIA_TIPO } from '../../pages/Utils/Constants';
import CardEx from '../Cards/CardEx';
import { Loading } from '../Loading/Loading';
import Semaphore from '../Semaphore/Semaphore';
import './GarantiaInfo.css';

export default function ExcepcionGarantiaInfo({
    garantiaInfo,
    isLoading = false
}) {
    const getTitleByTypeGarantia = useCallback((code) => {
        if (code === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
            return 'Carta Fianza'
        } else if (code === GARANTIA_TIPO.GAR0_EFECTIVO) {
            return 'Operaciones Efectivo'
        } else if (code === GARANTIA_TIPO.GAR2_SIN_GARANTIA) {
            return 'Sin Garantía'
        } else {
            return ''
        }
    }, []);

    const getUrlFileName = useCallback(() => {
        var fileName = "";

        switch (garantiaInfo?.detalleGarantia.tipo_garantia.codigo) {
            case GARANTIA_TIPO.GAR1_CARTA_FIANZA:
                fileName = garantiaInfo?.detalleGarantia.url_filename_carta_fianza;
                break;
            case GARANTIA_TIPO.GAR0_EFECTIVO:
                fileName = garantiaInfo?.detalleGarantia.url_filename_operacion;
                break;
            default:
                break;
        }

        return fileName;
    }, [garantiaInfo])


    return (
        <>
            <CardEx title={`Nro Contrato ${garantiaInfo?.garantia?.nro_contrato ?? ""}`}>
                {isLoading ? (
                    <div className="confirmWithLoader-overlay">
                        <div className='position-absolute top-50 start-50 translate-middle'>
                            <Loading></Loading>
                        </div>
                    </div>
                ) : null}

                <div className='row mt-2 mb-2'>
                    <div className='col-12 d-flex justify-content-center'>

                        <Semaphore
                            caption='CO'
                            size={'40px'}
                            fontSize={'16px'}
                            tooltipTitle={garantiaInfo?.detalleGarantia.excepcion.nombre_estado_cobranza}
                            lastUpdateDate={garantiaInfo?.detalleGarantia.excepcion.fecha_revision_cobranza}
                            lastUpdatedBy={garantiaInfo?.detalleGarantia.excepcion.usuario_revisor_cobranza}
                            tooltipDescription={""}
                            color={EXCEPCION_GARANTIA_ESTADO_COLOR[garantiaInfo?.detalleGarantia.excepcion.codigo_estado_cobranza]}>
                        </Semaphore>

                        {garantiaInfo?.detalleGarantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA ? (
                            <Semaphore
                                caption='TE'
                                size={'40px'}
                                fontSize={'16px'}
                                tooltipTitle={garantiaInfo?.detalleGarantia.excepcion.nombre_estado_tesoreria}
                                lastUpdateDate={garantiaInfo?.detalleGarantia.excepcion.fecha_revision_tesoreria}
                                lastUpdatedBy={garantiaInfo?.detalleGarantia.excepcion.usuario_revisor_tesoreria}
                                tooltipDescription={""}
                                color={EXCEPCION_GARANTIA_ESTADO_COLOR[garantiaInfo?.detalleGarantia.excepcion.codigo_estado_tesoreria]}>
                            </Semaphore>
                        ) : null}

                    </div>
                </div>
                <div className='row mt-2 mb-2'>
                    <div className='col-12 d-flex justify-content-center'>
                        <span className='badge badge-pill badge-secondary badge-text-small'>
                            {garantiaInfo?.garantia?.estado_garantia?.nombre}
                        </span>
                        {
                            garantiaInfo?.garantia?.is_excepcion
                            && <span className='badge badge-pill badge-danger badge-text-small ms-3'>Con Excepción: {garantiaInfo?.garantia?.excepcion?.nombre_tipo_excepcion}</span>
                        }
                    </div>
                </div>
                <div className='row mb-5 mt-5 py-1 rounded-top bg-grey'>
                    <div className='col-12 py-1 d-flex align-items-center'>
                        <i className="fi fi-rr-ballot-check fs-3 me-2"></i>
                        <span className='fs-4 text-gray-light'>Datos Generales</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold'>Ruc</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.garantia?.ruc}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Razon Social</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.garantia?.razon_social}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Nombre Comercial</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.garantia.nombre_comercial}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Mall</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.garantia?.mall.nombre}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row mt-2 mb-5 py-1 rounded-top bg-grey'>
                    <div className='col-12 py-1 d-flex align-items-center'>
                        <i className="fi fi-rr-file-invoice-dollar fs-3 me-2"></i>
                        <span className='fs-4 text-gray-light'>{getTitleByTypeGarantia(garantiaInfo?.detalleGarantia.tipo_garantia?.codigo)}</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        {garantiaInfo?.detalleGarantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                            <div className='row mb-6 align-items-center'>
                                <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                    <label className='fs-5 fw-bold '>Nro Carta Fianza</label>
                                </div>
                                <div className='col-12 col-sm w-sm-100'>
                                    <a href={getUrlFileName()} target='_blank' className='ms-6' rel="noreferrer"><i className="fi fi-rr-download fs-4"></i> {garantiaInfo?.detalleGarantia.nro_carta_fianza}</a>

                                </div>
                            </div>
                        ) : garantiaInfo?.detalleGarantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO ? (
                            <div className='row mb-6 align-items-center'>
                                <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                    <label className='fs-5 fw-bold '>Nro Operaci&oacute;n</label>
                                </div>
                                <div className='col-12 col-sm w-sm-100'>
                                    <span className='ms-6'>{garantiaInfo?.detalleGarantia.nro_operacion}</span>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {garantiaInfo?.detalleGarantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && (
                        <div className='col-12 col-xl-6'>
                            <div className='row mb-6 align-items-center'>
                                <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                    <label className='fs-5 fw-bold '>Vigencia</label>
                                </div>
                                <div className='col-12 col-sm w-sm-100'>
                                    <span className='ms-6'>
                                        {garantiaInfo?.detalleGarantia.fecha_emision_carta_fianza && garantiaInfo?.detalleGarantia.fecha_vencimiento_carta_fianza && `${moment(garantiaInfo?.detalleGarantia.fecha_emision_carta_fianza).format("DD/MM/yyyy")} - ${moment(garantiaInfo?.detalleGarantia.fecha_vencimiento_carta_fianza).format("DD/MM/yyyy")}`}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Importe</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.garantia.moneda.codigo} {numeral(garantiaInfo?.detalleGarantia.importe).format('0,0.00')}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Banco</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.detalleGarantia.banco.nombre}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row mt-2 mb-5 py-1 rounded-top bg-grey'>
                    <div className='col-12 py-1 d-flex align-items-center'>
                        <i className="fi fi-rr-replace fs-3 me-2"></i>
                        <span className='fs-4 text-gray-light'>Datos de la Excepción</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Tipo Excepción</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.detalleGarantia.excepcion.nombre_tipo_excepcion}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Fecha de Venc.</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>
                                    {garantiaInfo?.detalleGarantia.excepcion.fecha_vencimiento && (
                                        `${moment(garantiaInfo?.detalleGarantia.excepcion.fecha_vencimiento).format("DD/MM/yyyy")}`
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Importe</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.detalleGarantia.excepcion.codigo_moneda} {numeral(garantiaInfo?.detalleGarantia.excepcion.importe).format('0,0.00')} </span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Sustento</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <a href={garantiaInfo?.detalleGarantia.excepcion.url_file_name_adjunto} target='_blank' rel='noreferrer' className='ms-6'>
                                    <i className="fi fi-rr-download fs-4"></i> {garantiaInfo?.detalleGarantia.excepcion.file_name_adjunto}</a>
                            </div>
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Motivo</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.detalleGarantia.excepcion.motivo}</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div className='row'>

                    {garantiaInfo?.detalleGarantia?.excepcion?.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.CARTA_FIANZA_A_EFECTIVO ? (
                        <>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Nro Operaci&oacute;n</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>{garantiaInfo?.detalleGarantia.excepcion.nro_operacion_efectivo}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Fecha Depósito</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>
                                            {garantiaInfo?.detalleGarantia.excepcion.fecha_deposito_efectivo && (
                                                `${moment(garantiaInfo?.detalleGarantia.excepcion.fecha_deposito_efectivo).format("DD/MM/yyyy")}`
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : garantiaInfo?.detalleGarantia?.excepcion?.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA ? (
                        <>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Nro Carta Fianza</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>{garantiaInfo?.detalleGarantia.excepcion.nro_carta_fianza}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Fecha de Vigencia</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>
                                            {garantiaInfo?.detalleGarantia.excepcion.fecha_emision_carta_fianza && garantiaInfo?.detalleGarantia.excepcion.fecha_vencimiento_carta_fianza && (
                                                `${moment(garantiaInfo?.detalleGarantia.excepcion.fecha_emision_carta_fianza).format("DD/MM/yyyy")} - ${moment(garantiaInfo?.detalleGarantia.excepcion.fecha_vencimiento_carta_fianza).format("DD/MM/yyyy")}`
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>

                    ) : null}
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Banco</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantiaInfo?.detalleGarantia.excepcion.nombre_banco}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </CardEx>


        </>
    )
}
